import { Classification, FoodClassification } from "./food-classification";

export const foodClassificationMapper: Record<Classification, FoodClassification> = {
  VEGETARIAN: {
    id: "VEGETARIAN",
    title: "Vegetariano",
    type: "suitableDiet",
    img: "/classification/vegetarian.svg",
    description: "Sem carne de nenhum tipo",
  },
  VEGAN: {
    id: "VEGAN",
    title: "Vegano",
    type: "suitableDiet",
    description: "Sem produtos de origem animal, como carne, ovo ou leite",
    img: "/classification/vegan.svg",
  },
  ORGANIC: {
    id: "ORGANIC",
    title: "Orgânico",
    type: "suitableDiet",
    description: "Cultivado sem agrotóxicos, segundo a lei 10.831",
    img: "/classification/organic.svg",
  },
  DIABETIC: {
    id: "DIABETIC",
    title: "Sem açúcar adicionado",
    type: "suitableDiet",
    img: "/classification/no-sugar.svg",
    description:
      "Não contém nenhum tipo de açúcar adicionado (cristal, orgânico, mascavo etc.)",
  },
  LOW_LACTOSE: {
    id: "LOW_LACTOSE",
    title: "Zero lactose",
    type: "suitableDiet",
    img: "/classification/zero-lactose.svg",
    description: "Não contém lactose, ou seja, leite e seus derivados",
  },
  GLUTEN_FREE: {
    id: "GLUTEN_FREE",
    title: "Gluten Free",
    type: "suitableDiet",
    img: "/classification/gluten-free.svg",
    description: "Não contém gluten, ou seja, pão, massa, etc",
  },
  COLD_DRINK: {
    id: "COLD_DRINK",
    title: "Bebida Gelada",
    description: "Da geladeira direto para o consumidoro",
    img: "/classification/cold_drink.svg",
    type: "suitableDiet",
  },
  ALCOHOL: {
    id: "ALCOHOL",
    title: "Bebida Alcoólica",
    type: "allergen",
    description: "De 0,5% a 54% em volume, destilados, fermentados etc",
    img: "/classification/beer.svg",

  },
  NATURAL: {
    id: "NATURAL",
    title: "Natural",
    type: "suitableDiet",
    description: "Preparados na hora com frutas frescas",
    img: "/classification/natural.svg",

  },
}
